import {Link} from 'react-router-dom';
import {useAuthStateManager} from '../../hooks/useAuthStateManager';
import {RoutePaths} from '../../RoutePaths';

/** The privacy note that the legacy page carried at the bottom of every view. */
const Footer = () => {
    const {isAuthenticated} = useAuthStateManager();

    return (
        <footer className="ft-footer text-center">
            Some names are hidden to protect the privacy of living relatives.
            {!isAuthenticated && (
                <>
                    {' '}
                    <Link to={RoutePaths.accounts.login()}>Log in</Link> to see
                    them.
                </>
            )}
        </footer>
    );
};

export default Footer;
